var map = {
	"./กุน.png": 2049,
	"./ขาล.png": 2050,
	"./จอ.png": 2051,
	"./ฉลู.png": 2052,
	"./ชวด.png": 2053,
	"./มะเมีย.png": 2054,
	"./มะเส็ง.png": 2055,
	"./มะแม.png": 2056,
	"./มะโรง.png": 2057,
	"./ระกา.png": 2058,
	"./วอก.png": 2059,
	"./เถาะ.png": 2060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 698;